import {connect} from "react-redux";

import CourseStatus from "../../../components/Dashboard/DashboardUser/CourseStatus";
import * as VideoActions from '../../../store/actions/videoActions';


const mapStateToProps = (state) => ({
    ...state.auth,
    ...state.video
});

const mapDispatchToProps = (dispatch) => ({
    onLoad: (profileId, courseId, token) => {
        dispatch(VideoActions.getUserCourseContent(courseId, token));
        dispatch(VideoActions.getCourseUser(profileId, token));
    },
    getCurrentSubject: (subjectId, token) => {
        dispatch(VideoActions.getUserSubject(subjectId, token));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CourseStatus);


// WEBPACK FOOTER //
// ./src/containers/Dashboard/DashboardUser/CourseStatusContainer.js